import React from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {TransfersFilter} from './TransfersFilter.js';
import {TransfersTable} from './TransfersTable';
import {TransfersFooter} from './TransfersFooter';
import FooterBar from '../../_common/components/FooterBar';

export function TransfersCard() {

  return (
    <Card className={'flex-fill bg-transparent shadow-none'} id={'transfers-list-card'}>
      <TransfersFilter/>
      <TransfersTable/>
      <FooterBar>
        <TransfersFooter/>
      </FooterBar>
    </Card>
  );
}
